import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from "@/api/PMS/closedRepairManage/closedRepairManage";
export default {
  props: ["keyValue", "showDialog"],
  components: {},
  computed: {
    colsData: function colsData() {
      return this.childData.cols * 1;
    }
  },
  data: function data() {
    return {
      currentStep: 0,
      disabledSq: false,
      seatData: [],
      rules: {
        theaterName: [{
          required: true,
          message: '请输入剧场名称',
          trigger: 'change'
        }],
        capacity: [{
          required: true,
          message: '请输入容纳人数',
          trigger: 'change'
        }],
        userName: [{
          required: true,
          message: '请输入联系人',
          trigger: 'change'
        }],
        mobilephone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          min: 11,
          max: 11,
          message: '请输入11位手机号',
          trigger: 'change'
        }],
        rows: [{
          required: true,
          message: '请输入横排',
          trigger: 'change'
        }],
        cols: [{
          required: true,
          message: '请输入竖排',
          trigger: 'change'
        }]
      },
      childData: {
        rows: 0,
        cols: 0
      },
      selectItem: null
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    createData: function createData() {
      var _this = this;

      this.currentStep = 1;
      this.disabledSq = true;
      var data = [];
      data = new Array(this.childData.rows * 1).fill(0).map(function () {
        return new Array(_this.childData.cols * 1).fill(0);
      });

      for (var x = 0; x < data.length; x++) {
        for (var y = 0; y < data[x].length; y++) {
          data[x][y] = {
            id: "",
            XCoord: x,
            YCoord: y,
            SeatCode: '',
            Status: '0',
            RowNum: x + 1,
            ColumnNum: y + 1,
            Price: ''
          };
        }
      }

      console.log(data);
      this.seatData = data;
    },
    closeEditRowCol: function closeEditRowCol() {
      this.selectItem = null;
    },
    // handCreate1 () {
    //   console.log(this.seatData.flat());
    // },
    prevStep: function prevStep() {
      if (this.currentStep == 1) {
        this.disabledSq = false;
      }

      if (this.currentStep >= 1) {
        this.currentStep--;
      }
    },
    nextStep: function nextStep() {
      if (this.currentStep <= 1) {
        this.currentStep++;
      }
    },
    clickItemStep1: function clickItemStep1(rowIndex, colIndex) {
      if (this.seatData[rowIndex][colIndex].Status == "0" || this.seatData[rowIndex][colIndex].Status == "2") {
        this.$set(this.seatData[rowIndex][colIndex], "Status", "-1");
      } else {
        this.$set(this.seatData[rowIndex][colIndex], "Status", "0");
      }
    },
    clickItemStep2: function clickItemStep2(rowIndex, colIndex) {
      this.selectItem = this.seatData[rowIndex][colIndex];
    },
    onRightClick: function onRightClick(rowIndex, colIndex) {},
    init: function init() {
      var _this2 = this;

      this.currentStep = 0;
      this.disabledSq = false;
      this.seatData = [];
      this.closeEditRowCol();
      this.$nextTick(function () {
        _this2.$refs["dataForm"].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this2.childData = response.data.data;
          _this2.childData.week = _this2.childData.week.toString();
        });
      } else {
        this.childData = {
          rows: 0,
          cols: 0
        };
      }
    },
    handCreate: function handCreate() {
      var _this3 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          // if (this.childData.startTime > this.childData.endTime) {
          //   this.Alert({
          //     alertType: "error",
          //     message: "闭馆维修开始日期不能大于闭馆维修结束日期"
          //   });
          //   return;
          // }
          if (_this3.currentStep < 1) {
            _this3.Alert({
              alertType: "error",
              message: "请生成数据"
            });

            return;
          }

          console.log(_this3.seatData);

          if (_this3.keyValue > 0) {
            fetchUpdate(_this3.childData).then(function (res) {
              if (res.data.code == 200) {
                _this3.$emit("handCancle", true);

                _this3.Alert({
                  alertType: "update"
                });
              }
            });
          } else {
            fetchCreate(_this3.childData).then(function (res) {
              if (res.data.code == 200) {
                _this3.$emit("handCancle", true);

                _this3.Alert({
                  alertType: "add"
                });
              }
            });
          }
        } else {
          _this3.Alert({
            alertType: "valid"
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", false);
    }
  }
};